// Module
var code = `<graph-time-region-form panel-ctrl="ctrl"></graph-time-region-form>
`;
// Exports
var _module_exports =code;;
var path = 'public/app/plugins/panel/graph/tab_time_regions.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;